export function condenserProductDescription(
  description: string | null | undefined,
  productType: string | null | undefined
): string {
  return [description, productType]
    .filter((part): part is string => Boolean(part && part.trim()))
    .join(' ');
}
